/**
 * @generated SignedSource<<343b3f97aee1652cb1ff9893b3b75c1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CardBrand = "AMERICAN_EXPRESS" | "CHINA_UNIONPAY" | "DISCOVER" | "DISCOVER_DINERS" | "EBT" | "EFTPOS" | "FELICA" | "INTERAC" | "JCB" | "MASTERCARD" | "OTHER_BRAND" | "SQUARE_CAPITAL_CARD" | "SQUARE_GIFT_CARD" | "UNKNOWN" | "VISA";
export type AssignPaymentMethodToPackageInput = {
  id: string;
  squareCardId: string;
};
export type useAssignPaymentToPackageMutation$variables = {
  input: AssignPaymentMethodToPackageInput;
};
export type useAssignPaymentToPackageMutation$data = {
  readonly assignPaymentMethodToPackage: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
    } | null | undefined>;
    readonly memberPackage: {
      readonly id: string;
      readonly squareCard: {
        readonly cardBrand: CardBrand;
        readonly expMonth: number;
        readonly expYear: number;
        readonly id: string;
        readonly lastFour: string;
      } | null | undefined;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useAssignPaymentToPackageMutation = {
  response: useAssignPaymentToPackageMutation$data;
  variables: useAssignPaymentToPackageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberPackage",
  "kind": "LinkedField",
  "name": "memberPackage",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareCardOnFile",
      "kind": "LinkedField",
      "name": "squareCard",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastFour",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cardBrand",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expYear",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAssignPaymentToPackageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignPaymentMethodToPackagePayload",
        "kind": "LinkedField",
        "name": "assignPaymentMethodToPackage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAssignPaymentToPackageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignPaymentMethodToPackagePayload",
        "kind": "LinkedField",
        "name": "assignPaymentMethodToPackage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "015c168135e8cac2452133a42fd23267",
    "id": null,
    "metadata": {},
    "name": "useAssignPaymentToPackageMutation",
    "operationKind": "mutation",
    "text": "mutation useAssignPaymentToPackageMutation(\n  $input: AssignPaymentMethodToPackageInput!\n) {\n  assignPaymentMethodToPackage(input: $input) {\n    success\n    memberPackage {\n      id\n      squareCard {\n        id\n        lastFour\n        cardBrand\n        expMonth\n        expYear\n      }\n    }\n    errors {\n      __typename\n      code\n      field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "39c790847ccea0b734940bbfd16727fa";

export default node;
